<div class="snackbar-component-root"
     [ngClass]="{info, warning, success, error, neutral}">
  <div class="left-band"></div>
  <span class="icon"><mat-icon>{{getIcon()}}</mat-icon></span>
  <span>
    {{message}}
  </span>
</div>
